import React, { useEffect, useState } from 'react'
import { useParams, Link } from 'react-router-dom';
import Header from '../header/Header';
import Sidebarr from '../sidebar/Sidebar';
import VendorSidebar from '../sidebar/VendorSidebar';
import Footer from '../footer/Footer';
import axios from "../helper/axios";
import { useSelector, useDispatch } from "react-redux";
import "../product.css";

export default function ProductView() {
  let { type, id, productId } = useParams();
  const auth = useSelector(state => state.auth);
  const email = auth?.user?.email;
  const role = auth?.user?.role;

  const [chooseFile, setimages] = useState([]);

  const [product, setProduct] = useState([]);

  const [productName, setProductName] = useState("")
  const [productPrice, setProductPrice] = useState(0)
  const [productDesc, setProductDesc] = useState("")

  const [preview, setPreview] = useState([]);
  const [showResults, setShowResults] = React.useState(false)




  // Stock .... 

  const updateProduct = async (id) => {
    const formData = new FormData();
    Object.values(chooseFile).forEach(file => {
      console.log(file)
      formData.append("multiFile", file);
    });

    formData.append("email", productName)
    formData.append("role", productPrice)
    formData.append("name", productDesc)




    // const res = await axios.post("/addproductmanual",formData, {headers: {
    const res = await axios.post("/addproductmanual", formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    if (res.status === 200) {
      alert("Product Add Successfull");
    }
  }

  const arrayofFiles = []
  const onSelectFile = (e) => {
    setShowResults(true);
    setimages(e.target.files);

    for (var i = 0; i < e.target.files.length; i++) {
      arrayofFiles.push(e.target.files[i]);

    }

    let images = [];
    arrayofFiles.map((e) => {
      const ImageUrl = URL.createObjectURL(e);
      images.push(ImageUrl)

    })
    setPreview(images)
  }

  return (
    <div>
      <div className="sidebar-mini skin-green-light">
        <div className="wrapper">
          <Header />
          {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <section className="content-header">
              <h1>
                Edit Product
                <small>it all starts here</small>
              </h1>
              <ol className="breadcrumb">
                <li>
                  <a href="#">
                    <i className="fa fa-dashboard" /> Home
                  </a>
                </li>
                <li>
                  <a href="#">Examples</a>
                </li>
                <li className="active">Blank page</li>
              </ol>
            </section>
            {/* Main content */}




            <section className="content">
              <div className="box box-default xpadding">

                <div className="box-body xbox">
                  <div className="row">

                    <div className="col-md-4">
                      <h2>Add Product Description</h2>
                    </div>
                  </div>
                </div>

                < div className='product-image'>
                  <div className="">
                    <div className="box-body xbox">
                      <div className="row">
                        <div className="col-md-4">
                          <h2>Add Image</h2>
                        </div>
                      </div>
                    </div>
                    <div className="box-body xbox">
                      <div className="row">
                        <div className="col-md-4">
                          <label>Images</label>
                          <input
                            type="file"
                            className="form-control select2 select2-hidden-accessible"
                            style={{ width: "100%" }}
                            data-select2-id={1}
                            tabIndex={-1}
                            multiple
                            name="multiFile"
                            // onChange={(e)=>setimages(e.target.files)}
                            aria-hidden="true"
                            onChange={onSelectFile}
                          />
                        </div>
                        {showResults ?
                          <div className='col-md-4 uploded-img'>
                            <img src={preview[0]} alt='uplode image' />
                          </div>
                          :
                          null
                        }
                      </div>
                    </div>
                  </div>
                  {/* <div className="box-footer">
        <button className="btn btn-success" onClick={(e)=>updateProduct()}>Add Products</button>
      </div> */}
                </div>
                <div className="box-body xbox">
                  <div className="row">

                    <div className="col-md-12 addprodust">
                      <label>Product Name</label>
                      <input
                        type="text"
                        className="form-control select2 select2-hidden-accessible"
                        style={{ width: "100%" }}
                        data-select2-id={1}
                        tabIndex={-1}
                        onChange={(e) => setProductName(e.target.value)}
                        aria-hidden="true"
                      />
                    </div>
                    <div className="col-md-12 addprodust">
                      <label>Product Price</label>
                      <input
                        type="text"
                        className="form-control select2 select2-hidden-accessible"
                        style={{ width: "100%" }}
                        data-select2-id={1}
                        tabIndex={-1}
                        onChange={(e) => setProductPrice(e.target.value)}
                        aria-hidden="true"
                      />
                    </div>


                    <div className="col-md-12 addprodust">
                      <label>Product Description</label>
                      <input
                        type="text"
                        className="form-control select2 select2-hidden-accessible"
                        style={{ width: "100%" }}
                        data-select2-id={1}
                        tabIndex={-1}
                        onChange={(e) => setProductDesc(e.target.value)}
                        aria-hidden="true"
                      />
                    </div>





                  </div>
                </div>



                <div className="box-footer">

                  <button className="btn btn-success" onClick={(e) => updateProduct()}>Add Products</button>
                </div>
              </div>

            </section>
            {/* /.content */}
          </div>

          <Footer />

        </div>


      </div>
    </div>
  )
}